import React from 'react'
import Income from 'components/Income/Income'

const riseStatisticIconUrl = require('../../../../../icons/rise.svg')
const dropStatisticIconUrl = require('../../../../../icons/drop.svg')

export interface IActivityTopBarStatisticsData {
  totalEntities: number
  inflows: number
  outflows: number
  profitLoss: number
  profitLossType: 'decrease' | 'increase' | null
  reportedIncomeTax: number | null
  unReportedIncomeTax: number | null
  reportedSalesTax: number | null
  unReportedSalesTax: number | null
}

export const getActivityTopBarStatisticsData = (overview: IActivityTopBarStatisticsData) => [
  {
    label: 'Inflows',
    value: <Income value={overview.inflows} useCurrencyConversion={true} isFormatted={true} />,
    tooltipHeader: 'Inflows',
    tooltipText:
      'The total amount of cryptocurrency received across the selected address(es). Includes all incoming transactions such as deposits, payments, or transfers.',
  },
  {
    label: 'Outflows',
    tooltipHeader: 'Outflows',
    value: <Income value={overview.outflows} useCurrencyConversion={true} isFormatted={true} />,
    tooltipText:
      'The total amount of cryptocurrency sent from the selected address(es). Includes withdrawals, expenses, or transfers to other wallets.',
  },
  {
    label: 'Gain/Loss',
    tooltipHeader: 'Gain/Loss',
    value: (
      <>
        {overview.profitLossType === 'increase' && <img src={riseStatisticIconUrl} alt='increase' />}
        {overview.profitLossType === 'decrease' && <img src={dropStatisticIconUrl} alt='decrease' />}
        <Income value={overview.profitLoss} useCurrencyConversion={true} isFormatted={true} />
      </>
    ),
    tooltipText:
      'Total revenue from sales, mints, and royalties, minus fees and cost basis (initial purchase price of the asset)',
  },
  {
    label: 'Reported | Unreported Income Tax',
    value: (
      <>
        {typeof overview.reportedIncomeTax === 'number' ? (
          <Income value={overview.reportedIncomeTax} useCurrencyConversion={true} isFormatted={true} />
        ) : (
          '----'
        )}
        {' | '}
        {typeof overview.unReportedIncomeTax === 'number' ? (
          <span style={{ color: '#FF4D4F' }}>
            <Income value={overview.unReportedIncomeTax} useCurrencyConversion={true} isFormatted={true} />
          </span>
        ) : (
          '----'
        )}
      </>
    ),
  },
  {
    label: 'Reported | Unreported Sales Tax / VAT',
    comingSoon: true,
    value: (
      <>
        {typeof overview.reportedSalesTax === 'number' ? (
          <Income value={overview.reportedSalesTax} useCurrencyConversion={true} isFormatted={true} />
        ) : (
          '----'
        )}
        {' | '}
        {typeof overview.unReportedSalesTax === 'number' ? (
          <span style={{ color: '#FF4D4F' }}>
            <Income value={overview.unReportedSalesTax} useCurrencyConversion={true} isFormatted={true} />
          </span>
        ) : (
          '----'
        )}
      </>
    ),
  },
]
